module.exports = __webpack_public_path__ + "img/image2.66c6d025.jpg";